// @flow

import type { SearchNotification } from '../SearchNotifications/types';

export function disableAllSearchNotifications(
  searchNotifications: SearchNotification<*>[]
): SearchNotification<*>[] {
  return searchNotifications.map(searchNotification => ({
    ...searchNotification,
    active: false,
  }));
}



// WEBPACK FOOTER //
// ./app/NotificationsManager/webPush/DisableSearchNotifications/utils.js